import { render, staticRenderFns } from "./CustomerDiscounts.vue?vue&type=template&id=2ef1b828&"
import script from "./CustomerDiscounts.vue?vue&type=script&lang=js&"
export * from "./CustomerDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDiscounts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports